import {headingSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const MenuUIWrapper = styled.div(
  props => `
  width: 100%;
  border-radius: ${props.theme.misc.borderRadius.custom(12)};
`,
);
export const HeadingWrap = styled.div(
  props => `
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding: ${props.theme.spacing.custom(18)};
  `,
);
export const MenuHeader = styled.span`
  ${headingSizes.Base}
`;

export const offerContent = styled.ul(
  props => `
    display:${props.display || 'flex'};
    flex-direction: column;
    padding: 0 1.8rem 1.6rem;
      li{
        display:flex;
        margin-bottom: ${props.theme.spacing.large};
        align-items: flex-end;
        &:last-child{
          margin-bottom:0px;
        }
      }
      `,
);

export const OfferText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(16)};
    margin-left: ${props.theme.spacing.base};
    margin-bottom: ${props.theme.spacing.custom(3)};
    `,
);
